














































  import Vue from 'vue'
  import {
    Component,
    Prop
  } from 'vue-property-decorator'
  import ReviewForm from '../../../api/v2/forms/review'
  import Simplemde from '../atoms_molecules/Simplemde.vue'
  import {
    userState
  } from '../../stores/user'
  import {
    checkMobile
  } from '../../utils/utils'
  import {
    reviewState
  } from '../../stores/reviews'
  import Review from '../../../api/v2/models/review'

  @Component({
    components: {
      Simplemde
    }
  })
  export default class ReviewEditDialog extends Vue {
    @Prop({
      default: ''
    }) courseId: string
    @Prop({
      default: ''
    }) review: Review
    @Prop({
      default: ''
    }) enrollmentId: string

    dialog: boolean = false
    body: string = ''
    rank: number = 0
    hasReview: boolean = false
    invalidBody: boolean = false
    isNotConfirm: boolean = true
    confirmed: boolean = false
    mobile = checkMobile()

    get user() {
      return userState.user
    }

    mounted() {
      this.body = this.review.body
      this.rank = this.review.rank
    }

    get currentTime() {
      var today = new Date();
      return `${today.getFullYear()}-${(today.getMonth()+1)}-${today.getDate()}`;
    }

    async updateReview() {
      this.invalidBody = !this.body
      if (this.invalidBody) return
      this.isNotConfirm = false
      const reviewForm = new ReviewForm()

      reviewForm.rank = this.rank
      reviewForm.body = this.body

      await reviewState.update(this.review.id, reviewForm)

      setTimeout(() => {
        this.isNotConfirm = true
        this.dialog = false
      }, 3000)
    }
  }
